const mergeIframeClick = (event) => {
  const simulatedMouseDownEvent = new MouseEvent("mousedown", {
    bubbles: true,
    cancelable: true,
    view: window
  });
  const simulatedClickEvent = new MouseEvent("click", {
    bubbles: true,
    cancelable: true,
    view: window
  });
  Object.assign(simulatedClickEvent, { iframeData: event });
  Object.assign(simulatedMouseDownEvent, { iframeData: event });
  window.dispatchEvent(simulatedClickEvent);
  window.dispatchEvent(simulatedMouseDownEvent);
};
export {
  mergeIframeClick
};
//# sourceMappingURL=mergeIframeClick.mjs.map